// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ═════════════════════════════════════════════════════════════════════════
   Fiche de Déclaration Sinistre - Styles impression + écran
   Contraintes : 1 page A4 portrait, calque du formulaire papier BNCB.
   ═════════════════════════════════════════════════════════════════════════ */

.fiche-page {
  background: #f4f4f4;
  min-height: 100vh;
  padding: 20px 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.fiche-toolbar {
  width: 100%;
  max-width: 800px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
  padding: 10px 14px;
  background: white;
  border: 1px solid #e7e9ee;
  border-radius: 8px;
}

.fiche-sheet {
  width: 210mm;
  height: 297mm;
  background: white;
  padding: 10mm 10mm;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  font-family: 'Inter', Arial, sans-serif;
  color: #0b0f14;
  font-size: 7.7pt;
  line-height: 1.2;
  box-sizing: border-box;
  overflow: hidden;
}

/* ── Entête ── */
.fiche-header {
  display: grid;
  grid-template-columns: 44px 1fr 44px;
  align-items: flex-start;
  padding-bottom: 4px;
  margin-bottom: 6px;
  gap: 10px;
}
.fiche-logo {
  width: 40px; height: 40px;
  border-radius: 50%;
  border: 1.5px solid #1a6b3c;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-family: 'Playfair Display', Georgia, serif;
  font-weight: 700;
  font-size: 6.8pt;
  color: #1a6b3c;
  flex-shrink: 0;
}
.fiche-logo-img {
  width: 44px;
  height: 44px;
  object-fit: contain;
  display: block;
  flex-shrink: 0;
  print-color-adjust: exact;
}
.fiche-header-center {
  text-align: center;
}
.fiche-title {
  font-family: 'Inter', Arial, sans-serif;
  font-size: 9.9pt;
  font-weight: 700;
  letter-spacing: 0.5px;
  margin: 0;
  text-transform: uppercase;
  text-decoration: underline;
}
.fiche-subtitle {
  font-size: 7.2pt;
  color: #333;
  margin-top: 1px;
  font-style: italic;
  text-decoration: underline;
}
.fiche-redacteur {
  margin-top: 3px;
  font-size: 7.2pt;
  color: #0b0f14;
  font-weight: 600;
}
.fiche-redacteur em {
  font-style: italic;
  color: #5a6676;
  font-size: 6.8pt;
  font-weight: 400;
}

/* ── Bandeau BUREAU NATIONAL TOGO (ligne seule pleine largeur) ── */
.fiche-top-banner {
  border: 1px solid #0b0f14;
  border-bottom: none;
  padding: 3px 8px;
  display: flex;
  align-items: baseline;
  gap: 10px;
  font-size: 8.1pt;
}
.fiche-top-banner .label {
  font-size: 6.3pt;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  color: #5a6676;
  font-weight: 600;
}
.fiche-top-banner .label em {
  font-style: italic;
  font-weight: 400;
  color: #8a95a5;
  font-size: 5.9pt;
  margin-left: 2px;
}
.fiche-top-banner .value {
  font-weight: 700;
  font-size: 9.0pt;
  letter-spacing: 0.4px;
}

/* ── Bloc identification : 2 grandes cellules sans lignes internes ── */
.fiche-id-block {
  display: grid;
  grid-template-columns: 1fr 1fr;
  border: 1px solid #0b0f14;
  border-bottom: none;
}
.fiche-id-col {
  padding: 5px 8px;
  border-right: 1px solid #0b0f14;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.fiche-id-col:last-child {
  border-right: none;
}
.fiche-id-field .fiche-label {
  font-size: 5.9pt;
  text-transform: uppercase;
  letter-spacing: 0.2px;
  color: #5a6676;
  font-weight: 600;
  line-height: 1.15;
}
.fiche-id-field .fiche-label em {
  font-style: italic;
  font-weight: 400;
  color: #8a95a5;
  font-size: 5.4pt;
  margin-left: 2px;
}
.fiche-id-field .fiche-value {
  font-size: 8.1pt;
  font-weight: 500;
  color: #0b0f14;
  line-height: 1.2;
  min-height: 10pt;
}
.fiche-id-field .fiche-value.mono {
  font-family: 'JetBrains Mono', Menlo, monospace;
  letter-spacing: 0.3px;
  font-size: 7.7pt;
}

/* ── Tableaux (véhicules, conducteurs, dommages) ── */
.fiche-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 0;
  font-size: 7.7pt;
  table-layout: fixed;
}
.fiche-table th,
.fiche-table td {
  border: 1px solid #0b0f14;
  padding: 2.5px 5px;
  vertical-align: top;
}
.fiche-table .section-band {
  background: #ededed;
  text-align: center;
  font-weight: 700;
  font-size: 6.8pt;
  letter-spacing: 0.3px;
  padding: 2px 5px;
  text-transform: uppercase;
}
.fiche-table .section-band em {
  font-style: italic;
  color: #5a6676;
  font-weight: 400;
  text-transform: none;
  font-size: 6.3pt;
}

.fiche-label {
  font-size: 5.9pt;
  text-transform: uppercase;
  letter-spacing: 0.2px;
  color: #5a6676;
  font-weight: 600;
  line-height: 1.15;
}
.fiche-label em {
  font-style: italic;
  font-weight: 400;
  margin-left: 2px;
  color: #8a95a5;
  font-size: 5.4pt;
}
.fiche-value {
  font-size: 8.1pt;
  font-weight: 500;
  color: #0b0f14;
  padding-top: 1px;
  min-height: 11pt;
  line-height: 1.25;
}
.fiche-value.mono {
  font-family: 'JetBrains Mono', Menlo, monospace;
  letter-spacing: 0.3px;
  font-size: 7.7pt;
}

/* ── Cases à cocher ── */
.fiche-check {
  display: inline-block;
  width: 11pt;
  text-align: center;
  font-size: 9.0pt;
}

/* ── Bloc unifié (bas de fiche) - 1 seul rectangle ── */
.fiche-bloc-unifie {
  border: 1px solid #0b0f14;
  margin-top: 0;
  border-top: none;
}
.fiche-bloc-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  border-bottom: 1px solid #c8ccd2;
}
.fiche-bloc-row:last-child {
  border-bottom: none;
}
.fiche-bloc-cell {
  padding: 5px 8px;
  border-right: 1px solid #c8ccd2;
}
.fiche-bloc-cell:last-child {
  border-right: none;
}
.fiche-bloc-titre {
  text-align: center;
  font-size: 7.2pt;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  padding: 3px 8px;
  border-bottom: 1px solid #c8ccd2;
  background: #fafafa;
}
.fiche-bloc-titre em {
  font-style: italic;
  font-weight: 400;
  color: #5a6676;
  font-size: 6.8pt;
  text-transform: none;
}
.fiche-circonstances {
  padding: 5px 10px 8px;
  font-size: 8.1pt;
  min-height: 38pt;
  line-height: 1.35;
  border-bottom: 1px solid #c8ccd2;
}
.fiche-declarant-line {
  display: grid;
  grid-template-columns: 2fr 1fr;
  align-items: baseline;
  padding: 5px 10px;
  gap: 10px;
}
.fiche-declarant-line .dl-nom,
.fiche-declarant-line .dl-tel {
  font-size: 7.7pt;
}
.fiche-declarant-line .dl-label {
  font-size: 5.9pt;
  color: #5a6676;
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: 0.2px;
  margin-right: 4px;
}
.fiche-fait-a {
  text-align: right;
  padding: 4px 4px 2px;
  margin-top: 10mm;
  font-size: 7.7pt;
  border: none;
}
.fiche-fait-a em {
  font-style: italic;
  color: #5a6676;
  font-size: 6.8pt;
}

/* ── Dommages : CORPORELS / MATÉRIELS sur la même ligne ── */
.fiche-dommages-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
}

/* ── Bloc signature (HORS rectangle, espace pour tampon + paraphe manuel) ── */
.fiche-signature-zone {
  margin-top: 6px;
  padding: 0 4px;
}
.fiche-pour-bncb {
  font-size: 7.7pt;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  text-align: center;
  margin-bottom: 1px;
}
.fiche-se-label {
  font-size: 7.2pt;
  text-align: center;
  color: #2a3340;
  margin-bottom: 3px;
}
.fiche-se-label em {
  color: #5a6676;
  font-style: italic;
  font-size: 6.8pt;
}
/* Date à gauche, signature à droite : deux informations qui se lisent d'un même
   regard, et qui tiennent désormais dans la hauteur que la signature occupait
   seule. \`align-items: flex-end\` pose la date sur la même ligne de base que le
   trait de signature, comme sur un document signé à la main. */
.fiche-signature-rangee {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 10mm;
}
.fiche-fait-a-colonne {
  font-size: 7.7pt;
  color: #2a3340;
  padding-bottom: 2mm;
  white-space: nowrap;
}
.fiche-fait-a-colonne em {
  color: #5a6676;
  font-style: italic;
  font-size: 6.8pt;
}
.fiche-signature-colonne {
  flex: 0 0 auto;
  min-width: 70mm;
}
.fiche-signature-espace {
  min-height: 24mm;
  border-bottom: 1px dashed #c5cdd6;
}

/* ══════════ Print rules ══════════ */
@page {
  size: A4 portrait;
  margin: 0;
}

@media print {
  body, html {
    background: white !important;
    margin: 0 !important;
    padding: 0 !important;
  }
  .fiche-page {
    background: white;
    padding: 0;
  }
  .fiche-toolbar {
    display: none !important;
  }
  .fiche-sheet {
    box-shadow: none;
    width: 210mm;
    height: 297mm;
    margin: 0;
    padding: 10mm 10mm;
    page-break-after: avoid;
    page-break-inside: avoid;
  }
  .no-print {
    display: none !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/sinistres/ficheDeclaration.css"],"names":[],"mappings":"AAAA;;;8EAG8E;;AAE9E;EACE,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,yCAAyC;EACzC,uCAAuC;EACvC,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,oCAAoC;EACpC,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,WAAW,EAAE,YAAY;EACzB,kBAAkB;EAClB,2BAA2B;EAC3B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,+CAA+C;EAC/C,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,cAAc;EAEd,yBAAyB;AAC3B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,uCAAuC;EACvC,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,SAAS;EACT,yBAAyB;EACzB,0BAA0B;AAC5B;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,0BAA0B;AAC5B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,oEAAoE;AACpE;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,wEAAwE;AACxE;EACE,aAAa;EACb,8BAA8B;EAC9B,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,+CAA+C;EAC/C,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,sDAAsD;AACtD;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;;EAEE,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,+CAA+C;EAC/C,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,qBAAqB;EACrB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,wDAAwD;AACxD;EACE,yBAAyB;EACzB,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,gCAAgC;AAClC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,+BAA+B;AACjC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,iBAAiB;EACjB,SAAS;AACX;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA,6DAA6D;AAC7D;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA,+EAA+E;AAC/E;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;AACA;;;+DAG+D;AAC/D;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA,sCAAsC;AACtC;EACE,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE;IACE,4BAA4B;IAC5B,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,iBAAiB;IACjB,UAAU;EACZ;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,SAAS;IACT,kBAAkB;IAClB,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;AACF","sourcesContent":["/* ═════════════════════════════════════════════════════════════════════════\n   Fiche de Déclaration Sinistre - Styles impression + écran\n   Contraintes : 1 page A4 portrait, calque du formulaire papier BNCB.\n   ═════════════════════════════════════════════════════════════════════════ */\n\n.fiche-page {\n  background: #f4f4f4;\n  min-height: 100vh;\n  padding: 20px 12px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.fiche-toolbar {\n  width: 100%;\n  max-width: 800px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 14px;\n  padding: 10px 14px;\n  background: white;\n  border: 1px solid #e7e9ee;\n  border-radius: 8px;\n}\n\n.fiche-sheet {\n  width: 210mm;\n  height: 297mm;\n  background: white;\n  padding: 10mm 10mm;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n  font-family: 'Inter', Arial, sans-serif;\n  color: #0b0f14;\n  font-size: 7.7pt;\n  line-height: 1.2;\n  box-sizing: border-box;\n  overflow: hidden;\n}\n\n/* ── Entête ── */\n.fiche-header {\n  display: grid;\n  grid-template-columns: 44px 1fr 44px;\n  align-items: flex-start;\n  padding-bottom: 4px;\n  margin-bottom: 6px;\n  gap: 10px;\n}\n.fiche-logo {\n  width: 40px; height: 40px;\n  border-radius: 50%;\n  border: 1.5px solid #1a6b3c;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-family: 'Playfair Display', Georgia, serif;\n  font-weight: 700;\n  font-size: 6.8pt;\n  color: #1a6b3c;\n  flex-shrink: 0;\n}\n.fiche-logo-img {\n  width: 44px;\n  height: 44px;\n  object-fit: contain;\n  display: block;\n  flex-shrink: 0;\n  -webkit-print-color-adjust: exact;\n  print-color-adjust: exact;\n}\n.fiche-header-center {\n  text-align: center;\n}\n.fiche-title {\n  font-family: 'Inter', Arial, sans-serif;\n  font-size: 9.9pt;\n  font-weight: 700;\n  letter-spacing: 0.5px;\n  margin: 0;\n  text-transform: uppercase;\n  text-decoration: underline;\n}\n.fiche-subtitle {\n  font-size: 7.2pt;\n  color: #333;\n  margin-top: 1px;\n  font-style: italic;\n  text-decoration: underline;\n}\n.fiche-redacteur {\n  margin-top: 3px;\n  font-size: 7.2pt;\n  color: #0b0f14;\n  font-weight: 600;\n}\n.fiche-redacteur em {\n  font-style: italic;\n  color: #5a6676;\n  font-size: 6.8pt;\n  font-weight: 400;\n}\n\n/* ── Bandeau BUREAU NATIONAL TOGO (ligne seule pleine largeur) ── */\n.fiche-top-banner {\n  border: 1px solid #0b0f14;\n  border-bottom: none;\n  padding: 3px 8px;\n  display: flex;\n  align-items: baseline;\n  gap: 10px;\n  font-size: 8.1pt;\n}\n.fiche-top-banner .label {\n  font-size: 6.3pt;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n  color: #5a6676;\n  font-weight: 600;\n}\n.fiche-top-banner .label em {\n  font-style: italic;\n  font-weight: 400;\n  color: #8a95a5;\n  font-size: 5.9pt;\n  margin-left: 2px;\n}\n.fiche-top-banner .value {\n  font-weight: 700;\n  font-size: 9.0pt;\n  letter-spacing: 0.4px;\n}\n\n/* ── Bloc identification : 2 grandes cellules sans lignes internes ── */\n.fiche-id-block {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  border: 1px solid #0b0f14;\n  border-bottom: none;\n}\n.fiche-id-col {\n  padding: 5px 8px;\n  border-right: 1px solid #0b0f14;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n.fiche-id-col:last-child {\n  border-right: none;\n}\n.fiche-id-field .fiche-label {\n  font-size: 5.9pt;\n  text-transform: uppercase;\n  letter-spacing: 0.2px;\n  color: #5a6676;\n  font-weight: 600;\n  line-height: 1.15;\n}\n.fiche-id-field .fiche-label em {\n  font-style: italic;\n  font-weight: 400;\n  color: #8a95a5;\n  font-size: 5.4pt;\n  margin-left: 2px;\n}\n.fiche-id-field .fiche-value {\n  font-size: 8.1pt;\n  font-weight: 500;\n  color: #0b0f14;\n  line-height: 1.2;\n  min-height: 10pt;\n}\n.fiche-id-field .fiche-value.mono {\n  font-family: 'JetBrains Mono', Menlo, monospace;\n  letter-spacing: 0.3px;\n  font-size: 7.7pt;\n}\n\n/* ── Tableaux (véhicules, conducteurs, dommages) ── */\n.fiche-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-bottom: 0;\n  font-size: 7.7pt;\n  table-layout: fixed;\n}\n.fiche-table th,\n.fiche-table td {\n  border: 1px solid #0b0f14;\n  padding: 2.5px 5px;\n  vertical-align: top;\n}\n.fiche-table .section-band {\n  background: #ededed;\n  text-align: center;\n  font-weight: 700;\n  font-size: 6.8pt;\n  letter-spacing: 0.3px;\n  padding: 2px 5px;\n  text-transform: uppercase;\n}\n.fiche-table .section-band em {\n  font-style: italic;\n  color: #5a6676;\n  font-weight: 400;\n  text-transform: none;\n  font-size: 6.3pt;\n}\n\n.fiche-label {\n  font-size: 5.9pt;\n  text-transform: uppercase;\n  letter-spacing: 0.2px;\n  color: #5a6676;\n  font-weight: 600;\n  line-height: 1.15;\n}\n.fiche-label em {\n  font-style: italic;\n  font-weight: 400;\n  margin-left: 2px;\n  color: #8a95a5;\n  font-size: 5.4pt;\n}\n.fiche-value {\n  font-size: 8.1pt;\n  font-weight: 500;\n  color: #0b0f14;\n  padding-top: 1px;\n  min-height: 11pt;\n  line-height: 1.25;\n}\n.fiche-value.mono {\n  font-family: 'JetBrains Mono', Menlo, monospace;\n  letter-spacing: 0.3px;\n  font-size: 7.7pt;\n}\n\n/* ── Cases à cocher ── */\n.fiche-check {\n  display: inline-block;\n  width: 11pt;\n  text-align: center;\n  font-size: 9.0pt;\n}\n\n/* ── Bloc unifié (bas de fiche) - 1 seul rectangle ── */\n.fiche-bloc-unifie {\n  border: 1px solid #0b0f14;\n  margin-top: 0;\n  border-top: none;\n}\n.fiche-bloc-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  border-bottom: 1px solid #c8ccd2;\n}\n.fiche-bloc-row:last-child {\n  border-bottom: none;\n}\n.fiche-bloc-cell {\n  padding: 5px 8px;\n  border-right: 1px solid #c8ccd2;\n}\n.fiche-bloc-cell:last-child {\n  border-right: none;\n}\n.fiche-bloc-titre {\n  text-align: center;\n  font-size: 7.2pt;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n  padding: 3px 8px;\n  border-bottom: 1px solid #c8ccd2;\n  background: #fafafa;\n}\n.fiche-bloc-titre em {\n  font-style: italic;\n  font-weight: 400;\n  color: #5a6676;\n  font-size: 6.8pt;\n  text-transform: none;\n}\n.fiche-circonstances {\n  padding: 5px 10px 8px;\n  font-size: 8.1pt;\n  min-height: 38pt;\n  line-height: 1.35;\n  border-bottom: 1px solid #c8ccd2;\n}\n.fiche-declarant-line {\n  display: grid;\n  grid-template-columns: 2fr 1fr;\n  align-items: baseline;\n  padding: 5px 10px;\n  gap: 10px;\n}\n.fiche-declarant-line .dl-nom,\n.fiche-declarant-line .dl-tel {\n  font-size: 7.7pt;\n}\n.fiche-declarant-line .dl-label {\n  font-size: 5.9pt;\n  color: #5a6676;\n  text-transform: uppercase;\n  font-weight: 600;\n  letter-spacing: 0.2px;\n  margin-right: 4px;\n}\n.fiche-fait-a {\n  text-align: right;\n  padding: 4px 4px 2px;\n  margin-top: 10mm;\n  font-size: 7.7pt;\n  border: none;\n}\n.fiche-fait-a em {\n  font-style: italic;\n  color: #5a6676;\n  font-size: 6.8pt;\n}\n\n/* ── Dommages : CORPORELS / MATÉRIELS sur la même ligne ── */\n.fiche-dommages-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n}\n\n/* ── Bloc signature (HORS rectangle, espace pour tampon + paraphe manuel) ── */\n.fiche-signature-zone {\n  margin-top: 6px;\n  padding: 0 4px;\n}\n.fiche-pour-bncb {\n  font-size: 7.7pt;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n  text-align: center;\n  margin-bottom: 1px;\n}\n.fiche-se-label {\n  font-size: 7.2pt;\n  text-align: center;\n  color: #2a3340;\n  margin-bottom: 3px;\n}\n.fiche-se-label em {\n  color: #5a6676;\n  font-style: italic;\n  font-size: 6.8pt;\n}\n/* Date à gauche, signature à droite : deux informations qui se lisent d'un même\n   regard, et qui tiennent désormais dans la hauteur que la signature occupait\n   seule. `align-items: flex-end` pose la date sur la même ligne de base que le\n   trait de signature, comme sur un document signé à la main. */\n.fiche-signature-rangee {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 10mm;\n}\n.fiche-fait-a-colonne {\n  font-size: 7.7pt;\n  color: #2a3340;\n  padding-bottom: 2mm;\n  white-space: nowrap;\n}\n.fiche-fait-a-colonne em {\n  color: #5a6676;\n  font-style: italic;\n  font-size: 6.8pt;\n}\n.fiche-signature-colonne {\n  flex: 0 0 auto;\n  min-width: 70mm;\n}\n.fiche-signature-espace {\n  min-height: 24mm;\n  border-bottom: 1px dashed #c5cdd6;\n}\n\n/* ══════════ Print rules ══════════ */\n@page {\n  size: A4 portrait;\n  margin: 0;\n}\n\n@media print {\n  body, html {\n    background: white !important;\n    margin: 0 !important;\n    padding: 0 !important;\n  }\n  .fiche-page {\n    background: white;\n    padding: 0;\n  }\n  .fiche-toolbar {\n    display: none !important;\n  }\n  .fiche-sheet {\n    box-shadow: none;\n    width: 210mm;\n    height: 297mm;\n    margin: 0;\n    padding: 10mm 10mm;\n    page-break-after: avoid;\n    page-break-inside: avoid;\n  }\n  .no-print {\n    display: none !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
